import React from 'react';
import { motion } from 'framer-motion';
interface ButtonBaseProps {
  variant?: 'primary' | 'secondary' | 'ghost';
  children: React.ReactNode;
  className?: string;
}
type ButtonAsButton = ButtonBaseProps & Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'href'> & {
  href?: undefined;
};
type ButtonAsLink = ButtonBaseProps & Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & {
  href: string;
};
type ButtonProps = ButtonAsButton | ButtonAsLink;
export function Button({
  variant = 'primary',
  children,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'px-8 py-4 rounded-sm font-medium tracking-wide transition-all duration-300 inline-flex items-center justify-center gap-2 text-sm uppercase tracking-widest cursor-pointer';
  const variants = {
    primary: 'bg-gold text-black hover:bg-gold-light shadow-[0_0_20px_rgba(212,175,122,0.2)] hover:shadow-[0_0_30px_rgba(212,175,122,0.4)]',
    secondary: 'border border-gold/30 text-gold hover:bg-gold/10 hover:border-gold/60 backdrop-blur-sm',
    ghost: 'text-cream/70 hover:text-gold transition-colors'
  };
  const classes = `${baseStyles} ${variants[variant]} ${className}`;
  if ('href' in props && props.href) {
    return <motion.a whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={classes} target="_blank" rel="noopener noreferrer" {...props as React.AnchorHTMLAttributes<HTMLAnchorElement>} data-id="element-32">
        {children}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={classes} {...props as React.ButtonHTMLAttributes<HTMLButtonElement>} data-id="element-33">
      {children}
    </motion.button>;
}